import { MappedAnswer } from '../components/context/SurveyPageContext';
import QuestionInterface from '../interfaces/question';

interface FindAnswerProps {
  question: QuestionInterface;
  currentPageAnswers: MappedAnswer[];
}

const findAnswer = ({ question, currentPageAnswers }: FindAnswerProps): MappedAnswer | null => {
  const result = currentPageAnswers.find((answer) => answer.question.id === question.id);
  if (result === undefined) return null;
  return result;
};

export { findAnswer };
